import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ApplePayService } from '../../services/apple-pay/apple-pay.service';
import { ExternalDataService } from '../../services/external-data/external-data.service';

@Component({
  selector: 'app-apple-pay',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './apple-pay.component.html',
  styleUrl: './apple-pay.component.scss',
})
export class ApplePayComponent {
  public style = 'black';

  constructor(private applePayService: ApplePayService, private externalDataService: ExternalDataService) {
    externalDataService.$appleButtonstyle.subscribe((abs) => (this.style = abs));
  }

  onClick() {
    this.applePayService.tokenize();
  }
}
